import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import ReactCSSTransitionReplace from 'react-css-transition-replace';
import queryString from 'query-string';

import Immutable from 'seamless-immutable';
import { LoadingIndicator, ProgressBar, Button } from '../../components';
import { ThemeColors } from '../../theme';
import Question from './question';
import Answer from './answer';
import CardModal from './card-modal';

import results from '../../../images/result@2x.png';
import tests from '../../../images/tests@2x.png';
import goToCard from '../../../images/courses@2x.png';
import restart from '../../../images/restart.png';
import env from '../../../run-config';

import pdf from '../../../images/pdf.png';

import ENV from '../../../run-config';

const INITIAL_STATE = {
  questionIndex: 0,
  progress: 0,
  selectedAnswers: Immutable({}),
};

class QuestionAnswering extends Component {
  constructor(props) {
    super(props);

    this.state = INITIAL_STATE;
    this.answerSelectionChanged = this.answerSelectionChanged.bind(this);
    this.restart = this.restart.bind(this);
    this.exportView = queryString.parse(this.props.location.search).exportView;
        // this.resultId = queryString.parse(this.props.location.search).resultId;
  }

  componentWillMount() {
    const questionId = queryString.parse(this.props.location.search).questionId;
    if (questionId) this.props.loadQuestion(questionId);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.runStartedAt && nextProps.runStartedAt !== this.props.runStartedAt) {
      this.setState(Object.assign({}, INITIAL_STATE, {
        progress: nextProps.questions ? (1 / nextProps.questions.length) : 0,
        currentIndex: 1,
        totalQuestions: nextProps.questions ? nextProps.questions.length : 0,
      }));
    }

    if (!this.state.progress && nextProps.questions) {
      this.setState({
        progress: 1 / nextProps.questions.length,
        currentIndex: 1,
        totalQuestions: nextProps.questions.length,
      });
    }
  }

  onNextQuestion = (question) => {
    const questionIndex = this.state.questionIndex + 1;

    this.setState({
      questionIndex,
      progress: (questionIndex + 1) / this.props.questions.length,
      currentIndex: questionIndex + 1,
      totalQuestions: this.props.questions.length,
    });

    if (this.props.completed) {
      return;
    }

    if (this.props.testRun) {
      this.props.onSubmitAnswer(
        question,
        this.state.selectedAnswers[question.id],
        this.props.testRun.id);
    }

    if (question.id === this.props.questions[this.props.questions.length - 1].id) {
      this.props.onSubmitTest();
    }
  }

  onPrevQuestion = () => {
    const questionIndex = this.state.questionIndex - 1;

    this.setState({
      questionIndex,
      progress: (questionIndex - 1) / this.props.questions.length,
      currentIndex: questionIndex - 1,
      totalQuestions: this.props.questions.length,
    });
  }


  onClickShare = (question) => {
    const url = `${env.apiHost}/tests/${this.props.test.id}?questionId=${question.id}`;
    this.props.onExportContent(url);
  }


  restart() {
    this.props.removeTestRun(this.props.testRun.id);
    this.props.startNewTestRun(this.props.test);
    this.setState({
      progress: 0,
      questionIndex: 0,
    });

  }

  goToLinkedCard = () => {
    const cardId = this.props.questions[this.state.questionIndex].cardId;
    this.setState({ cardId });

    this.props.onLoadCard({ cardId });
  }

  closeLinkedCard = () => {
    this.setState({ cardId: null });

    this.props.onCloseLinkedCard();
  }

  buttonText() {
    if (this.state.questionIndex === this.props.questions.length - 1) {
      return this.props.completed ? 'Zurück' : 'Fertig';
    }
    return 'Weiter';
  }

  answerSelectionChanged(question, selectedAnswers) {
    let selectedAnswersForQuestion = this.state.selectedAnswers;

    selectedAnswersForQuestion = selectedAnswersForQuestion.set(question.id, selectedAnswers);

    this.setState({
      selectedAnswers: selectedAnswersForQuestion,
    });
  }

  shouldRenderLinkedCardButton = () => {
    if (this.props.hideLinkedCardButton) return null;
    const question = this.props.questions[this.state.questionIndex];

    return this.props.completed && question.cardId;
  }

  shouldRenderNextButton = () =>
  this.props.completed && this.state.questionIndex === this.props.questions.length - 1

  shouldRenderPrevButton = () => !this.props.completed || this.state.questionIndex === 0

  renderNextButton(question) {
    const { classes } = this.props;
    if (this.shouldRenderNextButton()) {
      return null;
    }
    return (<Button
      onClick={() => this.onNextQuestion(question)}
      label={this.buttonText()}
      variant="contained"
      className={`pm-course-button ${classes.buttonStyle}`}
      style={{ marginLeft: this.shouldRenderPrevButton() ? '50%' : 0, background: ThemeColors.positiveColor }}
      backgroundColor={ThemeColors.positiveColor}
      labelStyle={{ color: ThemeColors.positiveColorTextColor, fontSize: 12 }}
    />);
  }

  renderPrevButton(question) {
    const { classes } = this.props;
    if (this.shouldRenderPrevButton()) {
      return null;
    }
    return (<Button
      onClick={() => this.onPrevQuestion(question)}
      label={'Zurück'}
      variant="contained"
      className={`pm-course-button pm-course-button-first ${classes.buttonStyle}`}
            // className={classes.buttonStyle}
      style={{ background: ThemeColors.negativeColor }}
      labelStyle={{ color: '#ffffff' }}
    />);
  }

  renderLinkedCardButton() {
    const { classes } = this.props;

    if (!this.shouldRenderLinkedCardButton()) {
      return null;
    }
    return (
      <Button
        onClick={this.goToLinkedCard}
        label="Zum zugehörigem Kärtchen" className={classes.sideButtonStyle}
        icon={<img src={goToCard} style={{ width: 45, height: 45 }} alt="to card" />}
        secondary labelStyle={{ textAlign: 'left', color: '#222' }}
      />
    );
  }

    //   renderRetryTestButton(){
    //     if(this.props.test.examId) return null;

    //     return (
    //       <Button
    //       onClick={this.loadTest.bind(this, null)}
    //       label="Test wiederholen" style={styles.sideButtonStyle}
    //       icon={<img src={restart} style={{ width: 45, height: 45 }} />}
    //       secondary labelStyle={{ textAlign: 'left', color: '#222' }}
    //     />
    //     )
    //   }



  renderExportButton(question) {
    const { classes } = this.props;

    if (!ENV.exportFeature || (
        this.props.config.sharingEnabled && this.props.config.sharingEnabled === 'false')) {
      return null;
    }
    return (
      <Button
        onClick={() => this.onClickShare(question)}
        label="Frage jetzt downloaden"
        className={classes.sideButtonStyle}
        icon={<img
          alt="pdf download"
          src={pdf}
          className={classes.iconStyle}
        />}
      />
    );
  }

  renderButtons(question) {
    const { classes } = this.props;
    if (this.props.hideSideBarButtons) return null;

    if (this.props.completed) {
      return (
        <div>
          <div className="doNotPrint">
            {this.renderLinkedCardButton()}
            {/* {this.renderRetryTestButton()} */}
            {/* <Button
              onClick={this.props.onOpenResults}
              label="Zu meinen Ergebnissen"
              className={classes.sideButtonStyle}
              secondary
              icon={<img src={results} style={{ width: 45, height: 45 }} alt="results" />}
              labelStyle={{ textAlign: 'left', color: '#222' }}
            /> */}
          </div>
          <div style={{ marginTop: 25, paddingLeft: 22 }} className="breakBefore">
            <Answer
              small answer={{ text: 'Richtig beantwortet', isValidAnswer: true, answeredCorrectly: true }}
              completed={this.props.completed}
            />
            <Answer
              small answer={{ text: 'Richtige Antwort, nicht ausgewählt', isValidAnswer: true }}
              completed={this.props.completed}
            />
            <Answer
              small answer={{ text: 'Falsch ausgewählt' }}
              completed={this.props.completed}
            />
          </div>
        </div>
      );
    }
    return (
      <div className="doNotPrint">
        <Button
          onClick={this.restart}
          label="Test neu starten"
          secondary
          icon={<img src={restart} style={{ width: 45, height: 45 }} alt="restart test" />}
          className={classes.sideButtonStyle}
          labelStyle={{ textAlign: 'left', color: '#222' }}
        />
        <Button
          onClick={this.props.onOpenTests}
          label="Zur Testübersicht"
          className={classes.sideButtonStyle}
          icon={<img src={tests} style={{ width: 45, height: 45 }}alt="test overview" />}
          secondary
          labelStyle={{ textAlign: 'left', color: '#222' }}
        />
        {this.renderExportButton(question)}
      </div>
    );
  }

  renderContent() {
    let question = this.props.questions[this.state.questionIndex];

    const questionId = queryString.parse(this.props.location.search).questionId;
    if (questionId) {
      question = this.props.questions.find(q => q.id === questionId);

      if (!question) question = this.props.currentQuestion;
    }

    if (!question) {
      return null;
    }


    return (
      <div>
        <div className="col-sm-12 col-md-8 col-lg-8" style={{ marginBottom: '40px' }}>

          <ReactCSSTransitionReplace transitionName="carousel-swap">
            <Question
              key={question.id}
              question={question}
              answerSelectionChanged={this.answerSelectionChanged}
              completed={this.props.completed}
              showAll={this.props.exportView}
            />
          </ReactCSSTransitionReplace>
          <div className="doNotPrint">
            {this.renderPrevButton(question)}
            {this.renderNextButton(question)}
          </div>
        </div>

        <div className="col-sm-12 col-md-4 col-lg-4">
          {this.props.sideBarContent}
          {this.renderButtons(question)}
        </div>

        <div className="col-md-12 col-lg-10 doNotPrint" style={{ marginBottom: 50, marginTop: 10 }}>
          {/* <Group
            group={{ name: 'Weitere Tests', children: this.props.tests }}
            onClick={this.loadTest.bind(this)}
          /> */}
        </div>
      </div>
    );
  }

  render() {
    if (this.props.isLoading) {
      return <LoadingIndicator show centered />;
    }

    if (!this.props.test) {
      return null;
    }

    return (
      <div>
        <div className="col-md-12 col-lg-12">
          <div style={{ paddingLeft: '5px', position: 'relative' }}>
            <h1
              style={{ color: ThemeColors.accent2Color }}
            >{
              this.props.test.name || this.props.test.testName}
            </h1>
            <span style={{ right: 0, position: 'absolute', top: 20}}>{this.state.questionIndex}/{this.state.totalQuestions}</span>
          </div>
          <div style={{ marginBottom: 20 }}>
            <ProgressBar progress={this.state.progress} />
          </div>
        </div>
        {this.renderContent()}
        <CardModal
          open={!!this.state.cardId}
          card={this.props.card}
          onClose={this.closeLinkedCard}
        />
      </div>
    );
  }

}

const styles = () => ({
  buttonStyle: {
    fontSize: '14px',
    marginTop: '20px',
    height: 60,
  },
  sideButtonStyle: {
    textAlign: 'left',
    display: 'block',
    minWidth: 260,
    marginBottom: 5,
    height: 50,
  },
  iconStyle: {
    width: 45,
    height: 45,
  },
});

QuestionAnswering.propTypes = {
  classes: PropTypes.object.isRequired,
  location: PropTypes.object,
  runStartedAt: PropTypes.object,
  test: PropTypes.object,
  card: PropTypes.object,
  testRun: PropTypes.object,
  config: PropTypes.object,
  completed: PropTypes.bool,
  isLoading: PropTypes.bool,
  exportView: PropTypes.bool,
  hideLinkedCardButton: PropTypes.bool,
  hideSideBarButtons: PropTypes.bool,
  questions: PropTypes.array,
  onRestart: PropTypes.func,
  onSubmitAnswer: PropTypes.func,
  onSubmitTest: PropTypes.func,
  onLoadCard: PropTypes.func,
  onCloseLinkedCard: PropTypes.func,
  onOpenResults: PropTypes.func,
  onOpenTests: PropTypes.func,
  sideBarContent: PropTypes.any,
};

QuestionAnswering.defaultProps = {
  location: null,
  runStartedAt: null,
  test: null,
  card: null,
  testRun: null,
  config: null,
  completed: false,
  isLoading: false,
  exportView: false,
  hideLinkedCardButton: false,
  hideSideBarButtons: false,
  questions: [],
  onRestart: () => {},
  onSubmitAnswer: () => {},
  onSubmitTest: () => {},
  onLoadCard: () => {},
  onCloseLinkedCard: () => {},
  onOpenResults: () => {},
  onOpenTests: () => {},
  sideBarContent: () => {},
};

export default withStyles(styles)(QuestionAnswering);



// WEBPACK FOOTER //
// ./src/app/components/question_answering/question-answering.js